// src/api/onboardingApi.ts

import { baseApi } from './baseApi';
import type {
  UserOnboardingState,
  UpdateOnboardingStateRequest,
  CompleteOnboardingResponse,
  OnboardingPresetsResponse,
} from '../types/api';

export const onboardingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOnboardingState: builder.query<UserOnboardingState, void>({
      query: () => '/onboarding/state',
      providesTags: ['Onboarding'],
    }),

    updateOnboardingState: builder.mutation<UserOnboardingState, UpdateOnboardingStateRequest>({
      query: (body) => ({
        url: '/onboarding/state',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Onboarding'],
    }),

    completeOnboarding: builder.mutation<CompleteOnboardingResponse, void>({
      query: () => ({
        url: '/onboarding/complete',
        method: 'POST',
      }),
      invalidatesTags: ['Onboarding', { type: 'Workspace', id: 'LIST' }],
    }),

    getOnboardingPresets: builder.query<OnboardingPresetsResponse, void>({
      query: () => '/onboarding/presets',
    }),
  }),
});

export const {
  useGetOnboardingStateQuery,
  useUpdateOnboardingStateMutation,
  useCompleteOnboardingMutation,
  useGetOnboardingPresetsQuery,
} = onboardingApi;
